import type { Bereich } from '@/core/settings'
import { useSettings } from './settings'

const BEREICHE: Bereich[] = ['see', 'binnen']

export interface BereichWahlProps {
  /** Wird nach dem Wechsel gerufen, damit der Abschnitt seinen Stoff neu zieht. */
  onWechsel?: (bereich: Bereich) => void
  /** Der Satz darunter, der sagt, welche Ordnung gilt. Im Katalog ja, im Quiz nicht. */
  mitHinweis?: boolean
}

/**
 * Der Umschalter zwischen See und Binnen.
 *
 * Er steht überall dort, wo Stoff gezeigt wird: im Katalog, im Quiz und bei den
 * Karteikarten. Sonst lernte jemand im Katalog die Ordnung und bekäme im Quiz die KVR,
 * ohne dass ihm das gesagt würde, und genau diese stille Vermischung ist der Fehler,
 * den Block 5 verhindern soll. Die Wahl steht in den Einstellungen und gilt in allen
 * Abschnitten zugleich.
 */
export function BereichWahl({ onWechsel, mitHinweis = false }: BereichWahlProps) {
  const { t, settings, update } = useSettings()
  const bereich = settings.bereich

  return (
    <>
      <div className="modes catalogue__bereich" role="group" aria-label={t('bereich.label')}>
        {BEREICHE.map((b) => (
          <button
            key={b}
            type="button"
            className={`modes__item${bereich === b ? ' modes__item--on' : ''}`}
            data-bereich={b}
            data-testid={`bereich-${b}`}
            aria-pressed={bereich === b}
            onClick={() => {
              if (b === bereich) return
              update({ bereich: b })
              onWechsel?.(b)
            }}
          >
            {t(b === 'see' ? 'bereich.see' : 'bereich.binnen')}
          </button>
        ))}
      </div>
      {mitHinweis && (
        <p className="catalogue__bereich-note" data-testid="bereich-note">
          {t(bereich === 'see' ? 'bereich.see.note' : 'bereich.binnen.note')}
        </p>
      )}
    </>
  )
}
